import { Compass } from "lucide-react";
import { useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

import { useMiRol } from "../datos/useMiRol";
import { abrirGuia } from "./estado";
import { papelDe, type PapelGuia } from "./pasos";

/**
 * «Ver guía» arriba a la derecha de Inicio (Robert, 02/11/2026). El setter y el consultor abren
 * la suya; Jan y Robert eligen cuál ver (para saber qué ve cada uno).
 */
export const BotonGuia = ({ soloIcono }: { soloIcono?: boolean }) => {
  const translate = useTranslate();
  const rol = useMiRol();
  // Hasta saber el papel no se abre nada (el botón cambia de forma para Jan y Robert).
  const cargado = rol.esAdmin || rol.vende || rol.esConsultor;
  const boton = (props: { onClick?: () => void }) => (
    <Button
      variant="outline"
      size={soloIcono ? "icon" : "sm"}
      className={cn("gap-2", soloIcono ? "size-9 rounded-full" : "h-9")}
      aria-label={translate("nevora.guia.ver")}
      data-testid="boton-guia"
      disabled={!cargado}
      {...props}
    >
      <Compass className="size-4" aria-hidden />
      {soloIcono ? null : translate("nevora.guia.ver")}
    </Button>
  );
  if (!rol.esAdmin) return boton({ onClick: () => abrirGuia(papelDe(rol)) });
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>{boton({})}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="font-normal text-xs text-muted-foreground">
          {translate("nevora.guia.que_guia")}
        </DropdownMenuLabel>
        {(["setter", "consultor"] as PapelGuia[]).map((p) => (
          <DropdownMenuItem key={p} onSelect={() => abrirGuia(p)}>
            {translate(`nevora.guia.de_${p}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
